
import React from 'react';
import AnimateInView from '@/components/ui/animate-in-view';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

interface CallToActionProps {
  title: string;
  subtitle: string;
  primaryButtonText: string;
  primaryButtonLink: string;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
  bgColor?: string;
  textColor?: string;
}

const CallToAction: React.FC<CallToActionProps> = ({
  title,
  subtitle,
  primaryButtonText,
  primaryButtonLink,
  secondaryButtonText,
  secondaryButtonLink,
  bgColor = "bg-forti-fi-charcoal",
  textColor = "text-white"
}) => {
  return (
    <section aria-labelledby="cta-heading" className={`section ${bgColor} ${textColor} my-0 mx-auto py-12 px-4`}>
      <div className="container mx-auto text-center max-w-3xl">
        <AnimateInView animation="fade-in">
          <h2 id="cta-heading" className="mb-6">
            {title}
          </h2>
          <p className="mb-8 text-forti-fi-lavender text-xl">
            {subtitle}
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button asChild size="lg" className="bg-gold hover:bg-gold/90 text-forti-fi-charcoal font-medium">
              <Link to={primaryButtonLink}>
                {primaryButtonText}
              </Link>
            </Button>
            
            {secondaryButtonText && secondaryButtonLink && (
              <Button asChild size="lg" variant="outline" className="border-forti-fi-lavender text-forti-fi-lavender hover:bg-white/5">
                <Link to={secondaryButtonLink}>
                  {secondaryButtonText}
                </Link>
              </Button>
            )}
          </div>
        </AnimateInView>
      </div>
    </section>
  );
};

export default CallToAction;
